import * as React from 'react';

import type {User} from 'nutshell-core/types';

import {NavbarRightSection} from './navbar-right-section';

type Props = {
    userInitials: string;
    user: User | null | undefined;
};

export function NavbarSparse(props: Props) {
    return (
        <div className='nut-navbar--container'>
            <NavbarRightSection
                isSparse={true}
                user={props.user}
                userInitials={props.userInitials}
            />
        </div>
    );
}
